export default __webpack_public_path__ + "../staticImages/sprite-app-store-de-2x.png";